import { components } from "@/__openapi__/backend/schema";
import { MDSLoadingSpinner } from "@/mds";
import { observer } from "mobx-react-lite";
import { StyledContainer, StyledLoadingContainer } from "./floating-calendar-event-preview.style";
import { FloatingCalendarEventPreviewView } from "./floating-calendar-event-preview.view";

type NoteSourceCalendarEventArtifactData =
  components["schemas"]["CalendarEventArtifactInternalResponseSchema"];

interface FloatingCalendarEventPreviewProps {
  isOpen: boolean;
  isLoading: boolean;
  artifactData: NoteSourceCalendarEventArtifactData | null;
  connectedCalendarEventId: string;
}

export const FloatingCalendarEventPreview = observer(function FloatingCalendarEventPreview({
  isLoading,
  artifactData,
  connectedCalendarEventId,
}: FloatingCalendarEventPreviewProps) {
  if (isLoading) {
    return (
      <StyledContainer>
        <StyledLoadingContainer>
          <MDSLoadingSpinner size={24} />
        </StyledLoadingContainer>
      </StyledContainer>
    );
  }

  if (!artifactData) return null;
  const {
    event_start_time,
    event_end_time,
    is_all_day,
    description,
    organizer,
    attendees,
    attachments,
    html_link,
    meet_link,
  } = artifactData;

  return (
    <FloatingCalendarEventPreviewView
      startTime={event_start_time ?? undefined}
      endTime={event_end_time ?? undefined}
      isAllDay={is_all_day ?? false}
      description={description ?? undefined}
      host={organizer ?? undefined}
      guests={attendees}
      attachments={attachments}
      htmlLink={html_link ?? undefined}
      meetLink={meet_link ?? undefined}
      connectedCalendarEventId={connectedCalendarEventId}
    />
  );
});
